"use client";

import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { useEffect, useRef, useState } from "react";
export default function Hero() {
  const {
    ref: headlineRef,
    isVisible: headlineVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const {
    ref: subheadingRef,
    isVisible: subheadingVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const {
    ref: ctaRef,
    isVisible: ctaVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const parallaxRef = useRef<HTMLDivElement>(null);
  const [offsetY, setOffsetY] = useState(0);
  useEffect(() => {
    const handleScroll = () => {
      if (parallaxRef.current) {
        const rect = parallaxRef.current.getBoundingClientRect();
        const scrolled = window.scrollY;
        const elementTop = rect.top + scrolled;
        const elementHeight = rect.height;
        const viewportHeight = window.innerHeight;
        if (scrolled + viewportHeight > elementTop && scrolled < elementTop + elementHeight) {
          const offset = (scrolled - elementTop) * 0.3;
          setOffsetY(offset);
        }
      }
    };
    window.addEventListener("scroll", handleScroll);
    handleScroll();
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);
  return <section id="hero" className="dark bg-background text-foreground relative h-screen overflow-hidden !bg-[url(https://unitylanguageacademy.10web.cloud/wp-content/uploads/2026/02/Screenshot-2026-01-15-194438.jpg)] !bg-[url(https://unitylanguageacademy.10web.cloud/wp-content/uploads/2026/02/Screenshot-2026-01-15-194438.jpg)]" ref={parallaxRef}>
      <div className="absolute inset-0 bg-cover bg-center bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1537408/img/hero_campus_sunlit_modern.png)] transition-transform duration-0 ease-linear" style={{
      transform: `translateY(${offsetY}px)`
    }}>
        <div className="absolute inset-0 bg-gradient-to-b from-primary/60 to-primary/30"></div>
      </div>

      <div className="relative z-10 flex h-full flex-col items-center justify-center px-6 text-center">
        <div className="container max-w-4xl">
          <h1 ref={headlineRef} className="font-display leading-[1.1] font-bold tracking-[-1px] text-white mb-6 transition-all duration-300 opacity-100 translate-y-0 !text-justify !text-6xl !rounded-sm !shadow-none" style={{
          transitionDelay: headlineVisible ? "0ms" : "0ms"
        }}>&nbsp; &nbsp; &nbsp; Unity Language Academy</h1>

          <p ref={subheadingRef} className={`text-xl md:text-2xl text-white/95 mb-12 max-w-2xl mx-auto transition-all duration-300 ${subheadingVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`} style={{
          transitionDelay: subheadingVisible ? "150ms" : "0ms"
        }}>&nbsp; &nbsp; &nbsp; &nbsp; Excellence in English. Confidence for the World.</p>

          <div ref={ctaRef} className={`flex flex-col sm:flex-row gap-4 justify-center items-center transition-all duration-300 ${ctaVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`} style={{
          transitionDelay: ctaVisible ? "300ms" : "0ms"
        }}>
            <Button asChild size="lg" className="btn-primary shadow-strong min-w-[200px]">
              <Link to="/AdmissionsAndContactPage">Enroll Now</Link>
            </Button>

            <Button asChild variant="outline" size="lg" className="bg-white/10 backdrop-blur-md border-2 border-white/30 text-white hover:bg-white/20 hover:border-white/40 shadow-medium min-w-[200px] transition-all duration-300">
              <Link to="/AdmissionsAndContactPage">
                Take a Free Placement Test
              </Link>
            </Button>
          </div>
        </div>
      </div>
    </section>;
}